import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { withMemberGate } from "@/lib/with-member-gate";
import { ChevronLeft } from "lucide-react";
import { EftFlashcardFlow } from "@/components/eft/EftFlashcardFlow";

export const Route = createFileRoute("/eft-flashcards_/$slug")({
  loader: async ({ params }) => {
    const { getEftExercise } = await import("@/data/eft-flashcards");
    const exercise = getEftExercise(params.slug);
    if (!exercise) throw notFound();
    return { exercise };
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {
        meta: [
          { title: "Not found — Recovery Trauma™" },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    const { exercise } = loaderData;
    const description = `${exercise.description} A guided EFT tapping round from Recovery Trauma™, one flashcard at a time.`;
    return {
      meta: [
        { title: `${exercise.title} — EFT Tapping Flashcards · Recovery Trauma™` },
        { name: "description", content: description },
        { property: "og:title", content: `${exercise.title} — EFT Tapping` },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
    };
  },
  notFoundComponent: ExerciseNotFound,
  component: withMemberGate(EftExercisePage, "EFT Tapping Flashcards"),
});

function ExerciseNotFound() {
  return (
    <main className="mx-auto max-w-2xl px-4 py-16 text-center">
      <h1 className="font-display text-2xl text-foreground">We couldn&apos;t find that exercise</h1>
      <Link to="/eft-flashcards" className="mt-4 inline-block text-[var(--gold-deep)] hover:underline">
        Back to EFT Tapping Flashcards
      </Link>
    </main>
  );
}

function EftExercisePage() {
  const { exercise } = Route.useLoaderData();

  return (
    <main className="mx-auto max-w-xl px-4 py-8 pb-24">
      <Link
        to="/eft-flashcards"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ChevronLeft className="h-4 w-4" /> All tapping exercises
      </Link>

      <div className="mt-5">
        <EftFlashcardFlow exercise={exercise} />
      </div>
    </main>
  );
}
